import CreditAndBackgroundCheck from "./CreditAndBackgroundCheck";

export default CreditAndBackgroundCheck;
